import type { MenuItem } from '@/types';

export function findPageTitle(menu: MenuItem[], currentPath: string): string | null {
    for (const item of menu) {
        if ('path' in item && item.path === currentPath) {
            return item.title;
        }

        if ('items' in item) {
            const foundTitle = findPageTitle(item.items, currentPath);
            if (foundTitle) {
                return foundTitle;
            }
        }
    }

    return null;
}
